import { render, staticRenderFns } from "./PublishRecordDialog.vue?vue&type=template&id=5578a9f3&scoped=true"
import script from "./PublishRecordDialog.vue?vue&type=script&lang=js"
export * from "./PublishRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishRecordDialog.vue?vue&type=style&index=0&id=5578a9f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578a9f3",
  null
  
)

export default component.exports